angular.module('assets')
    .component('assetStockType', {
        bindings: {
            stockType: '<?'
        },
        template: `
            <span ng-if="$ctrl.stockType === 'SINGLE'" title="{{ 'asset.type.SINGLE' | translate }}"><i class="fa fa-fw fa-product-hunt"></i></span>
            <span ng-if="$ctrl.stockType === 'DISPOSABLE'" title="{{ 'asset.type.DISPOSABLE' | translate }}"><i class="fa fa-fw fa-eraser"></i></span>
        `
    })
